import { render, staticRenderFns } from "./EmployeeRegistryFileDocumentUpload.vue?vue&type=template&id=315a496c&"
import script from "./EmployeeRegistryFileDocumentUpload.vue?vue&type=script&lang=js&"
export * from "./EmployeeRegistryFileDocumentUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports